import React, { useState } from "react";
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function ExpandableImage(props) {
  const [open, setOpen] = useState(false);

  let style = Object.assign(
    { cursor: "pointer" },
    props.style || { height: "40px", width: "40px", objectFit: "cover" }
  );

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setOpen(true);
    }
  };

  return (
    <Box>
      <Box
        onClick={() => setOpen(true)}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-label="Expand image"
        style={{ display: "inline-block" }}
      >
        <img alt="" src={props.src} style={style} />
      </Box>
      <Box>{props.children}</Box>
      <Dialog
        fullScreen
        scroll="paper"
        open={open}
        onClose={() => setOpen(false)}
        onClick={() => setOpen(false)}
      >
        <DialogTitle style={{ backgroundColor: "#000", color: "#fff", margin: "0", border: 0 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              aria-label="close"
              onClick={() => setOpen(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "#FFF",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent style={{ backgroundColor: "#000", color: "#fff", alignItems: "center" }}>
          <Box textAlign="center">
            <img alt="" src={props.src} style={{ maxWidth: "100%", maxHeight: "90vh" }} />
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
export default ExpandableImage;
